import Immutable from "immutable";

export default {
    DISMISS_MESSAGES: state => {
        return Immutable.fromJS({ opened: false });
    },
    TRIGGER_MESSAGES: (state, action) => {
        return Immutable.fromJS({ opened: true, ...action.payload });
    }
};
